import { CacheProvider } from "../contex/cache";
import { ApiClient } from "./client"

export class UserProvider {
    static ready = false
    static users: User[]

    private static _usersMap: Map<number, User>
    private static _apiClient = new ApiClient();

    static async init() {
        if (this.ready) return;
        this.users = await this.getAllUsers();
        this._usersMap = new Map(this.users.map(u => [u.UserId, u]));
        this.ready = true;
    }

    static get activeUsers() { return this.users.filter(u => u.UserId > 2 && u.UserAccessLevel > 1); }

    static getUser(userId: number) {
        return this._usersMap.get(userId);
    }

    static getUserName(userId: number) {
        const user = this.getUser(userId);
        return user?.UserName || '?';
    }

    static async getAllUsers() {
        return CacheProvider.getOrCreate<User[]>('metdata.users', () =>
            this._apiClient.get('/metadata/users'), 1);
    }
}

export interface User {
    UserId: number
    UserName: string
    UserEmail: string
    UserAccessLevel: number
    UserInitials: string
}